// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.fixed_button {
  width: 12em;
  height: 1.5em;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  color: #567db8;
  border: 0;
  border-radius: 2px;
  cursor: pointer;
}
.fixed_button.autoW {
  width: auto;
}
.fixed_button__container {
  z-index: 200;
  right: 0;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 10px;
}
.fixed_button__blue {
  background: #dae1ec;
}
.fixed_button__blue:disabled {
  background: rgba(218, 225, 236, 0.5411764706);
  cursor: default;
  color: rgba(86, 125, 184, 0.4117647059);
}
.fixed_button__blue:disabled:hover {
  color: rgba(86, 125, 184, 0.4117647059);
}
.fixed_button__transparent {
  background: #f5f5f5;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
}
.fixed_button__transparent:disabled {
  background: #f5f5f5;
  cursor: default;
  color: rgba(86, 125, 184, 0.4117647059);
}
.fixed_button__transparent:hover {
  background: #dae1ec;
}
.fixed_button__red {
  background-color: #f3cfcc;
}
.fixed_button__delete {
  margin-left: 10px;
  background: #f3cfcc;
}
.fixed_button__delete:disabled {
  background: #f1dedc;
  cursor: default;
  color: rgba(86, 125, 184, 0.4117647059);
}
.fixed_button__delete:disabled:hover {
  color: rgba(86, 125, 184, 0.4117647059);
}
.fixed_button__red {
  margin-left: 10px;
  background: #f3cfcc;
}
.fixed_button__red:disabled {
  background: #f1dedc;
  cursor: default;
  color: rgba(86, 125, 184, 0.4117647059);
}
.fixed_button__red:disabled:hover {
  color: rgba(86, 125, 184, 0.4117647059);
}
.fixed_button.autoWidth {
  width: max-content;
  word-wrap: normal;
  overflow-wrap: normal;
  word-break: keep-all;
  white-space: nowrap; /* Запретить перенос текста по строчке */
  display: inline-block;
}

.btn__upload {
  display: flex;
  align-items: center;
  height: 2em;
  padding: 0 5px;
  border: 0;
  background: transparent;
  cursor: pointer;
}
.btn__upload label {
  display: flex;
  align-items: center;
}
.btn__upload:disabled {
  cursor: not-allowed;
  opacity: 50%;
}
.btn__upload p {
  display: inline;
  font-style: italic;
  font-weight: 400;
}

.close_btn {
  position: absolute;
  top: 0;
  right: 0;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  background-color: aliceblue;
  font-size: 20px;
  line-height: 19px;
  font-weight: 300;
  margin-top: -5px;
  cursor: pointer;
}

.img_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0;
  cursor: pointer;
}
.img_btn img {
  width: 1em;
  height: 1em;
}
.img_btn .img_disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.img_btn.definedFilters {
  background-color: #dae1ec;
  border-radius: 50%;
  width: 3em;
  height: 3em;
  box-shadow: rgba(0, 0, 0, 0.2) 0 3px 5px -1px, rgba(0, 0, 0, 0.14) 0 6px 10px 0, rgba(0, 0, 0, 0.12) 0 1px 18px 0;
}
.filter_btn {
  background: transparent;
  border: 0;
  cursor: pointer;
  position: relative;
  display: inline-block;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
  white-space: nowrap;
  width: 100%;
  font-size: "0.8em";
}

.left_fixed_btn {
  position: absolute;
  left: 1em;
  bottom: 1em;
}

.reestr_btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  background: transparent;
  border: 0;
}
.reestr_btn .label {
  white-space: nowrap;
}
.reestr_btn:disabled {
  cursor: default;
  opacity: 50%;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Buttons.scss","webpack://./src/Components/App/vars.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EAEE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,gBAAA;EAEA,cAAA;EACA,SAAA;EACA,kBAAA;EAEA,eAAA;AAJF;AAWE;EACE,WAAA;AATJ;AAYE;EAKE,YAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,SAAA;AAdJ;AAkBE;EACE,mBAAA;AAhBJ;AAkBI;EACE,6CAAA;EACA,eAAA;EACA,uCAAA;AAhBN;AAkBM;EACE,uCAAA;AAhBR;AAsBE;EACE,mBAAA;EACA,iDC1DU;ADsCd;AAqBI;EACE,mBAAA;EACA,eAAA;EACA,uCAAA;AAnBN;AAsBI;EACE,mBAAA;AApBN;AA0BE;EACE,yBAAA;AAxBJ;AA2BE;EACE,iBAAA;EACA,mBAAA;AAzBJ;AA0BI;EACE,mBAAA;EACA,eAAA;EACA,uCAAA;AAxBN;AA0BM;EACE,uCAAA;AAxBR;AA6BE;EACE,iBAAA;EACA,mBAAA;AA3BJ;AA4BI;EACE,mBAAA;EACA,eAAA;EACA,uCAAA;AA1BN;AA4BM;EACE,uCAAA;AA1BR;AAoCE;EACE,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA,EAAA,wCAAA;EACA,qBAAA;AAlCJ;;AAqCA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AAlCF;AAmCE;EACE,aAAA;EACA,mBAAA;AAjCJ;AAoCE;EACE,mBAAA;EACA,YAAA;AAlCJ;AAqCE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AAnCJ;;AAuCA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,iDAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AApCF;;AAuCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AApCF;AAqCE;EACE,UAAA;EACA,WAAA;AAnCJ;AAqCE;EACE,YAAA;EACA,mBAAA;AAnCJ;AAqCE;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EAGA,iHAAA;AArCJ;AA0CA;EACE,uBAAA;EACA,SAAA;EAEA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,iDAAA;EAEA,mBAAA;EACA,WAAA;EACA,kBAAA;AA1CF;;AA8CA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AA3CF;;AA8CA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AA3CF;AA4CE;EACE,mBAAA;AA1CJ;AA6CE;EACE,eAAA;EACA,YAAA;AA3CJ","sourcesContent":["@import \"../Components/App/vars.scss\";\n\n.fixed_button {\n  // border: none;\n  width: 12em;\n  height: 1.5em;\n  box-sizing: border-box;\n  justify-content: center;\n  align-items: center;\n  // padding: 2px 1em;\n  font-weight: 500;\n  // font-size: 13px;\n  color: #567db8;\n  border: 0;\n  border-radius: 2px;\n\n  cursor: pointer;\n  // right: 0;\n  &:hover {\n    // color: #426ba6;\n    // font-weight: 700;\n  }\n\n  &.autoW {\n    width: auto;\n  }\n\n  &__container {\n    // width: 335px;\n    // position: relative;\n    // margin-top: -20px;\n    // left: 20px;\n    z-index: 200;\n    right: 0;\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n    gap: 10px;\n    // position: relative;\n  }\n\n  &__blue {\n    background: #dae1ec;\n\n    &:disabled {\n      background: #dae1ec8a;\n      cursor: default;\n      color: #567db869;\n      // background: #3b4c63;\n      &:hover {\n        color: #567db869;\n        // font-weight: 700;\n      }\n    }\n  }\n\n  &__transparent {\n    background: #f5f5f5;\n    border: $border-thin;\n    &:disabled {\n      background: #f5f5f5;\n      cursor: default;\n      color: #567db869;\n      // background: #3b4c63;\n    }\n    &:hover {\n      background: #dae1ec;\n      // color: #567db869;\n      // font-weight: 700;\n    }\n  }\n\n  &__red {\n    background-color: #f3cfcc;\n  }\n\n  &__delete {\n    margin-left: 10px;\n    background: #f3cfcc;\n    &:disabled {\n      background: #f1dedc;\n      cursor: default;\n      color: #567db869;\n      // background: #3b4c63;\n      &:hover {\n        color: #567db869;\n        // font-weight: 700;\n      }\n    }\n  }\n  &__red {\n    margin-left: 10px;\n    background: #f3cfcc;\n    &:disabled {\n      background: #f1dedc;\n      cursor: default;\n      color: #567db869;\n      // background: #3b4c63;\n      &:hover {\n        color: #567db869;\n        // font-weight: 700;\n      }\n    }\n  }\n\n  // &:disabled{\n  //     cursor:default;\n  //     opacity: 50%;\n  // }\n  &.autoWidth {\n    width: max-content;\n    word-wrap: normal;\n    overflow-wrap: normal;\n    word-break: keep-all;\n    white-space: nowrap; /* Запретить перенос текста по строчке */\n    display: inline-block;\n  }\n}\n.btn__upload {\n  display: flex;\n  align-items: center;\n  height: 2em;\n  padding: 0 5px;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  label {\n    display: flex;\n    align-items: center;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 50%;\n  }\n\n  p {\n    display: inline;\n    font-style: italic;\n    font-weight: 400;\n  }\n}\n\n.close_btn {\n  position: absolute;\n  top: 0;\n  right: 0;\n  border: 1px solid #426ca65e;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  height: 20px;\n  background-color: aliceblue;\n  font-size: 20px;\n  line-height: 19px;\n  font-weight: 300;\n  margin-top: -5px;\n  cursor: pointer;\n}\n\n.img_btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  img {\n    width: 1em;\n    height: 1em;\n  }\n  .img_disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n  &.definedFilters {\n    background-color: #dae1ec;\n    border-radius: 50%;\n    width: 3em;\n    height: 3em;\n    // border-radius: $borderRadius;\n    // box-shadow: $filterBtnBoxShadow;\n    box-shadow: rgba(0, 0, 0, 0.2) 0 3px 5px -1px, rgba(0, 0, 0, 0.14) 0 6px 10px 0, rgba(0, 0, 0, 0.12) 0 1px 18px 0;\n  }\n  &.filterBtn {\n  }\n}\n.filter_btn {\n  background: transparent;\n  border: 0;\n\n  cursor: pointer;\n  position: relative;\n  display: inline-block;\n  border: 1px solid #426ca65e;\n\n  white-space: nowrap;\n  width: 100%;\n  font-size: \"0.8em\";\n  // background:#DAE1EC\n}\n\n.left_fixed_btn {\n  position: absolute;\n  left: 1em;\n  bottom: 1em;\n}\n\n.reestr_btn {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  .label {\n    white-space: nowrap;\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 50%;\n  }\n}\n","$border-thin: 1px solid #426ca65e;\n\n//colors\n$tableBgColor: #fff;\n$placeholderColor: #a3b9d9;\n$borderColor: #a3b9d9;\n$accentFilterColor: #ff8040;\n\n//fonts\n$baseFontSize: 16px;\n\n//sizes\n$baseHeight: 720;\n$baseWidth: 1190;\n$borderRadius: 5px;\n\n$inputSelectBgColor: #ffffffeb;\n$inputSelectHoverBgColor: #d6dfea93;\n\n//shadows\n$filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
